import { GET_BOOKING_DATA_SUCCESS } from '../constants';

export default function bookingDetails(state = {}, action) {
    switch (action.type) {
        case GET_BOOKING_DATA_SUCCESS:
            return {
                ...state,
                data: action.bookingDetails,
            };
        default:
            return state;
    }
}